import { ConfigService } from '../services/ConfigService';

const config = ConfigService.getInstance().values;

export const isEmailValid = (email: string): boolean => {
    const emailRule = config.constants.USER_EMAIL_VALIDATION_REGEX_RULE;
    const emailRegex = new RegExp(emailRule);
    return !!email && emailRegex.test(email);
}
